import React, { useRef, useState } from "react";
import { CSVLink } from "react-csv";
import "./FileInput.css";
import { createImport, Import } from "../../services/import";
import { toast } from "react-toastify";

interface FileInputProps {
  onImportSuccess: (importRecord: Import) => void;
}

const FileInput: React.FC<FileInputProps> = ({ onImportSuccess }) => {
  const csvData = [
    ["firstName", "lastName", "email"],
    ["John", "Doe", "john.doe@yahoo.com"],
    ["Mary", "", "mary@yahoo.com"],
  ];

  const fileInputRef = useRef<HTMLInputElement>(null);
  const [file, setFile] = useState<File | null>(null);

  const [uploading, setUploading] = useState<boolean>(false);
  const [uploadProgress, setUploadProgress] = useState<number>(0);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      if (event.target.files.length > 0) {
        setFile(event.target.files[0]);
      } else {
        setFile(null);
      }
    }
  };

  const handleUpload = async () => {
    setUploading(true);
    if (file) {
      try {
        const result = await createImport(file, (progressEvent) => {
          if (progressEvent.total) {
            const percentComplete = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setUploadProgress(percentComplete);
          }
        });
        onImportSuccess(result);
        toast.success("File imported successfully!");
        if (fileInputRef && fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      } catch {
        toast.error("Failed to import file! Please, try again later!");
        setUploadProgress(0);
      }

      setUploadProgress(0);
      setFile(null);
    } else {
      setFile(null);
    }
    setUploading(false);
  };

  return (
    <>
      <div className="fileUploadContainer">
        <input
          disabled={uploading}
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          className="fileInput"
        />
        <button
          onClick={handleUpload}
          className="uploadButton"
          disabled={file === null || uploading}
        >
          {uploadProgress > 0 ? `Uploading ${uploadProgress}%` : "Upload"}
        </button>
      </div>
      <div className="sampleContainer">
        <CSVLink
          filename={"sample-contacts.csv"}
          enclosingCharacter={""}
          data={csvData}
        >
          Download sample CSV
        </CSVLink>
      </div>
    </>
  );
};

export default FileInput;
